import { Table } from "@/features/Table";
import { type K2Transaction, porfolios_columns } from "./columns";
import {
  type FilterK2TransactionsSchema,
  FilterK2Transactions,
} from "./filter";

const client = "k2";
const table_name = "k2_transactions";

export const K2TransactionsTable = () => {
  return (
    <Table<K2Transaction, FilterK2TransactionsSchema>
      label="Transactions"
      client={client}
      table_name={table_name}
      columns={porfolios_columns}
      filter={<FilterK2Transactions />}
      actions={[
        {
          label: "actions.new",
          route: `k2/${table_name}/new`,
        },
      ]}
    />
  );
};
